import {fetchDashboardFailed, fetchDashboardSuccess} from "modules/actions/dashboard";
import {globalError} from "modules/actions/errors";
import {getSentryUser} from "modules/selectors";
import Api from "modules/utils/Api";
import ApiError from "modules/utils/Api/ApiError";
import {captureSentryError} from "modules/utils/sentry";
import {select} from "typed-redux-saga";
import {call, put} from "typed-redux-saga/macro";

export const fetchDashboardSaga = function* () {
	try {
		const response = yield* call(Api.Results.dashboard);

		ApiError.CHECK(response.data);

		yield* put(fetchDashboardSuccess(response.data.success.dashboard));
	} catch (e) {
		yield* put(globalError(e));
		yield* put(fetchDashboardFailed());
		const user = yield* select(getSentryUser);
		captureSentryError("fetchFriendPicksByPlayerSaga", "none", e, user);
	}
};
